export default __webpack_public_path__ + "static/media/loyola2.8a81581b.jpg";